import type { SxProps, Theme } from "@mui/material/styles";

export const feedFooterHeight = 160;

export const footerTransitionSx: SxProps<Theme> = { transition: "height 100ms ease-in" };

export const globalAudioPlayerHeight = 73;

export const topHeaderHeight = 80;
export const topHeaderHeightPx = `${topHeaderHeight}px`;
export const fullHeightMinusHeader = `calc(100vh - ${topHeaderHeight}px)`;

export const isDriverFeedPath = (pathname: string): boolean => /\/drivers\//.test(pathname);

export const isChannelFeedPath = (pathname: string): boolean => /\/channels\//.test(pathname);
